<template>
	<div class="layout-topbar">
		<router-link to="/guias" class="layout-topbar-logo">
			<img :src="topbarImage()" />
			<span>{{ name_company }}</span>
		</router-link>
		<button class="p-link layout-menu-button layout-topbar-button" @click="onMenuToggle">
			<i class="pi pi-bars"></i>
		</button>

		<button class="p-link layout-topbar-menu-button layout-topbar-button"
			v-styleclass="{ selector: '@next', enterClass: 'hidden', enterActiveClass: 'scalein', 
			leaveToClass: 'hidden', leaveActiveClass: 'fadeout', hideOnOutsideClick: true}">
			<i class="pi pi-ellipsis-v"></i>
		</button>

		<span>{{name_sucursal}}</span>

		<ul class="layout-topbar-menu hidden lg:flex origin-top">
			<!--li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-calendar"></i>
					<span>Events</span>
				</button>
			</li>
			<li>
				<button class="p-link layout-topbar-button">
					<i class="pi pi-cog"></i>
					<span>Settings</span>
				</button>
			</li-->
			<li>
				<SplitButton label="Logout" :model="items" />
				<button class="p-link layout-topbar-button">

				</button>
			</li>
		</ul>
	</div>
</template>

<script>
	import { ref, onMounted, computed } from 'vue';
	import * as authService from "@/services/auth.service.js";
	import  router from '@/router';
	export default {

		data(){

			return {	

					items: [
						{
							label: 'Salir',
							icon: 'pi pi-power-off',
							command: async ()  =>  {
								const {data} = await authService.logout()
							}
						}
					],
					name_sucursal:JSON.parse(localStorage.getItem('active_sucursal')).nombreSucursal,
					name_company:JSON.parse(localStorage.getItem('company')).razon_social
					
				};


		},

		onMounted(){
			
		},


		methods: {
			onMenuToggle(event) {
				this.$emit('menu-toggle', event);
			},
			onTopbarMenuToggle(event) {
				this.$emit('topbar-menu-toggle', event);
			},
			topbarImage() {
				let logo_path = JSON.parse(localStorage.getItem('company')).logo_path
				return this.$appState.darkTheme ? 'images/'+logo_path : 'images/'+logo_path
			}
	


			


		},
		computed: {
			darkTheme() {
				return this.$appState.darkTheme;
			}
			
		}
	}
</script>